export default __webpack_public_path__ + "static/new-itproactive-short-video-6-comp-1-699521cb04431a306ac253bade6e3fc1.mp4";